<template>
  <Nav></Nav>
  <main class="block organizations">
    <h1>組織</h1>
    <nav class="menu" v-if="editAccount">
      <router-link :to="{ name: 'Accounts' }">
        <font-awesome-icon icon="edit" />
        <span>アカウント管理</span>
      </router-link>
      <router-link v-if="loginedUser?.role == AccountRole.SUPER_ADMIN" to="/upload-json-file">
        <span class="label">JSONアップロード</span>
        <font-awesome-icon icon="upload" />
      </router-link>
    </nav>
    <Table :data="data" :headers="headers" :linkCols="linkCols" :newUri="newUri" :newCaption="newCaption"></Table>
  </main>
  <Dialog ref="error" class="dialog">
    <h4 class="title">Error</h4>
    <div class="message">
      <p class="text">{{ error.message }}</p>
    </div>
    <div class="action">
      <button class="btn btn-light" @click="errorClose">Close</button>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Dialog from '@/components/Dialog.vue';
import Nav from '@/components/Nav.vue';
import Table from '@/components/Table.vue';
import { Organization } from '@/lib/organization';
import { Account, AccountRole } from '@/lib/account';

export default defineComponent({
  name: 'Organizations',
  components: {
    Dialog,
    Nav,
    Table,
  },
  data() {
    return {
      data: [] as string[][],
      linkCols: [] as string[][],
      headers: [] as string[],
      newUri: '',
      newCaption: '',
      editAccount: false,
      error: {
        message: '',
      },
      AccountRole,
      loginedUser: {
        slug: '',
        email: '',
        first_name: '',
        last_name: '',
        password: '',
        role: 0,
        created: undefined,
        updated: undefined,
      }
    };
  },
  async created() {
    try {
      const ac = new Account();
      const currentAccount = await ac.getByToken();
      this.loginedUser = currentAccount;
      this.newCaption = currentAccount?.role < AccountRole.SUPER_ADMIN ? '' : '新しい組織の作成';
      this.newUri = currentAccount?.role < AccountRole.SUPER_ADMIN ? '' : '/new';
      this.editAccount = currentAccount?.role < AccountRole.ORGANIZATION_ADMIN ? false : true;
    } catch (e) {
      console.warn(e);
    }
  },
  async mounted() {
    const org = new Organization();
    try {
      const data = await org.all();
      if (data) {
        for (const row of data) {
          this.data.push([row.name]);
          this.linkCols.push([`./organizations/${row.slug}/projects`]);
        }
        this.headers.push('組織名');
      }
    } catch (e) {
      if (e instanceof Error) {
        this.error.message = e.message;
        (this.$refs.error as InstanceType<typeof Dialog>)?.open();
      }
      console.warn(e);
    }
  },
  methods: {
    errorClose() {
      (this.$refs.error as InstanceType<typeof Dialog>)?.close();
      this.$router.go(0);
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/assets/const.scss' as *;
@use '@/assets/dialog.scss' as *;

.organizations .menu {
  display: flex;
  flex-wrap: wrap;
  margin: 0 0.5rem 10px;
  justify-content: space-between;

  @media (min-width: $tablet) {
    margin: 0 20px 10px;
  }

  @media (min-width: $desktop) {
    margin: 0 40px 10px;
  }

  a {
    margin-right: 10px;
    text-decoration: none;
    color: inherit;

    &:last-child {
      margin-right: 0;
    }

    span {
      margin-right: 7px;
    }
  }
}

.dialog {
  @include dialog();
}
</style>
